import React from 'react';
import PropTypes from 'prop-types';

import './details-list-table.css';

const DetailsTable = ({ data }) => (
  <dl className="details-table">
    {data.map(({ category, features }) => (
      <div key={category} className="details-table-entry">
        <dt className="details-table-entry-title">{category}:</dt>
        <div className="details-table-entry-body">
          {features.map((feature) => (
            <dd key={feature} className="details-table-value">
              {feature}
            </dd>
          ))}
        </div>
      </div>
    ))}
  </dl>
);

DetailsTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      features: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
};

DetailsTable.defaultProps = {
  data: [],
};

export default DetailsTable;
